<template>
    <div class="site-type">

        <div class="account-poll-container">
            <star-condition-layout :onSearch="handleSearch" :onReset="reset" :loading="loading">
                <star-condition-cell label="分类名称">
                    <a-input v-model="query.subjectName" style="width: 100%" placeholder="请输入搜索的分类名称"
                             allowClear></a-input>
                </star-condition-cell>
                <star-condition-cell label="分类类别">
                    <a-select v-model="query.isDefault" style="width: 100%" allowClear>
                        <a-select-option value=""> 全部</a-select-option>
                        <a-select-option value="-1"> 人工添加</a-select-option>
                        <a-select-option value="1"> 系统默认</a-select-option>
                    </a-select>
                </star-condition-cell>
            </star-condition-layout>

        </div>

        <div class="site-typpe-inner">
            <TableHeadIcons :onRefresh="querySubjectList" :size.sync="tableDensity" :columns="columns">
                <a-button slot="right" type="primary" @click="handleAdd">
                    <a-icon type="plus"/>
                    新建
                </a-button>
            </TableHeadIcons>
            <a-table
                    :rowKey="(record) => record.subjectId"
                    :size="tableDensity"
                    :columns="showColumns"
                    :data-source="tableData"
                    :pagination="pagination"
                    @change="handleTableChange"
                    :loading="loading"
            >
        <span slot="type" slot-scope="text, record, index">
          {{ subjectType[record.type] }}
        </span>

                <span slot="isDefault" slot-scope="text, record, index">
          <span v-if="record.isDefault == 1"> 系统默认 </span>
          <span v-if="record.isDefault != 1"> 人工添加 </span>
        </span>
                <span slot="action" slot-scope="text, record">
          <a-button @click="handleDetail(record)" type="link">详情 </a-button>
          <a-divider type="vertical"/>
          <a-button @click="handleEdit(record)" type="link">编辑</a-button>
          <a-divider type="vertical"/>
          <a-popconfirm
                  :disabled="record.isDefault == 1"
                  title="确定要删除吗?"
                  @confirm="() => handleDelete(record)"
          >
         <a-tooltip placement="top">
        <template slot="title" v-if="record.isDefault == 1">
          <span>系统默认分类无法删除</span>
        </template>
           <a-button :disabled="record.isDefault == 1" type="link">删除 </a-button>
      </a-tooltip>

          </a-popconfirm>
        </span>
            </a-table>
            <a-modal
                    :title="formModel ? '修改分类' : '新增分类'"
                    @cancel="handleCancel"
                    :footer="null"
                    :visible="visible"
            >
                <Form :formModel="formModel" @onClose="handleCancel" @onSubmitSuccess="handleCloseModal"/>
            </a-modal>
        </div>
    </div>
</template>

<script>
  import Form from './Form'
  import { querySubjectListApi, deleteSubjectItemApi } from '@/api/TopicCrawl/WiliType'
  import { staticSubjectType } from '@/common/TopicCrawl/Subject'

  export default {
    data() {
      return {
        tableData: [],
        columns: [
          {
            title: '分类名称',
            dataIndex: 'subjectName',
            show: true
          },

          {
            title: '分类类别',
            dataIndex: 'isDefault',
            show: true,
            scopedSlots: { customRender: 'isDefault' }
          },

          {
            title: '采集总数(个)',
            dataIndex: 'subjectContentNum',
            show: true,
            align: 'center'
          },

          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: 180,
            show: true,
            align: 'center'
          },
          {
            title: '操作',
            key: 'action',
            scopedSlots: { customRender: 'action' },
            width: 180,
            show: true,
            align: 'center'
          }
        ],
        tableDensity: 'middle',
        formModel: null,
        visible: false,
        subjectType: staticSubjectType,
        pagination: {
          current: 1,
          pageSize: 10,
          showTotal: (total) => `共 ${total} 条`,
          showSizeChanger: true,
          showQuickJumper: true,
          total: 0,
          size: 'default'
        },
        loading: false,
        query: {
          pn: 1,
          pageSize: 10,
          width: 100,
          height: 100,
          needCountNum: true,
          isDefault: null
        }
      }
    },
    computed: {
      showColumns() {
        return this.columns.filter((item) => item.show)
      }
    },
    created() {
      this.querySubjectList()
    },
    methods: {
      handleDetail(record) {
        this.$router.push({
          name: 'collectlist',
          query: {
            subjectId: record.subjectId,
            subjectName: record.subjectName,
            type: record.type
          }
        })
      },

      handleAdd() {
        this.visible = true
        this.formModel = null
      },
      handleCloseModal() {
        this.visible = false
        this.querySubjectList()
      },
      handleSearch() {
        this.pagination.current = 1
        this.querySubjectList()
      },
      reset() {
        this.query.isDefault = null
        this.query.subjectName = null
        this.pagination.current = 1
        this.querySubjectList()
      },

      handleCancel() {
        this.visible = false
      },
      handleEdit(val) {
        this.visible = true
        this.formModel = val
      },

      handleTableChange(pagination) {
        this.pagination = pagination
        this.querySubjectList()
      },
      async querySubjectList() {


        this.query['pn'] = this.pagination.current
        this.query['pageSize'] = this.pagination.pageSize
        this.query['width'] = 100
        this.query['height'] = 100
        this.query['needCountNum'] = true

        this.loading = true
        let res = await querySubjectListApi(this.query)
        this.loading = false
        let { code, msg, data, extra } = res
        if (code == '200') {
          this.tableData = data
          this.pagination.total = extra.page.pageCount || 0
        } else {
          this.$message.error(msg)
        }
      },
      async handleDelete({ subjectId }) {
        let res = await deleteSubjectItemApi({
          subjectId
        })
        let { code, msg } = res
        if (code == '200') {
          this.$message.success(msg)
          this.querySubjectList()
        } else {
          this.$message.error(msg)
        }
      }
    },
    components: {
      Form
    }
  }
</script>

<style lang="less" scoped>

    .site-type {
        padding: 20px;

        .account-poll-container {
            width: 100%;
            margin-bottom: 20px;

            .table-container {
                background-color: white;
                padding: 0 16px;
                margin-top: 16px;
            }
        }

        .search {
            padding: 20px 20px 0 20px;
            background: #fff;
            margin-bottom: 20px;
        }

        .site-typpe-inner {
            padding: 0 16px;
            width: 100%;
            background: white;

            .title-solt-container {
                display: flex;
                flex-direction: row-reverse;
            }
        }
    }
</style>
